import React, { useEffect, useState } from 'react';
import { FiCheckCircle, FiX } from 'react-icons/fi';

const CompletionRecordModal = ({ onClose, onSave, plan }) => {
  const [actualContent, setActualContent] = useState(plan.actualContent || '');
  const [actualMinutes, setActualMinutes] = useState(Number(plan.actualMinutes) || Number(plan.expectedMinutes) || 0);
  const [understanding, setUnderstanding] = useState(Number(plan.understanding) || 0);
  const [memo, setMemo] = useState(plan.memo || '');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => event.key === 'Escape' && onClose();
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!actualContent.trim()) {
      setError('실제로 학습한 내용을 입력해 주세요.');
      return;
    }
    if (Number(actualMinutes) <= 0) {
      setError('실제 학습 시간을 입력해 주세요.');
      return;
    }
    if (!understanding) {
      setError('이해도를 선택해 주세요.');
      return;
    }

    setIsSaving(true);
    setError('');
    try {
      await onSave({
        ...plan,
        actualContent: actualContent.trim(),
        actualMinutes: Number(actualMinutes),
        understanding,
        memo: memo.trim(),
        status: 'completed',
      });
      onClose();
    } catch (saveError) {
      setError(saveError.message || '완료 기록을 저장하지 못했습니다.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="scheduler-record-modal" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <form className="scheduler-record" onSubmit={handleSubmit}>
        <header>
          <span><FiCheckCircle aria-hidden="true" /></span>
          <div>
            <h2>학습 완료 기록</h2>
            <p>{plan.subject} · {plan.startTime}~{plan.endTime}</p>
          </div>
          <button type="button" onClick={onClose} aria-label="닫기"><FiX aria-hidden="true" /></button>
        </header>

        <section className="scheduler-record__plan">
          <span>계획 내용</span>
          <strong>{plan.planContent}</strong>
        </section>

        <label>
          <span>실제 학습 내용</span>
          <textarea
            value={actualContent}
            onChange={(event) => setActualContent(event.target.value)}
            placeholder="실제로 학습한 내용을 간단히 기록하세요."
            maxLength={1000}
            autoFocus
          />
        </label>

        <label>
          <span>실제 학습 시간</span>
          <div className="scheduler-record__minutes">
            <input type="number" min="1" max="1440" value={actualMinutes} onChange={(event) => setActualMinutes(event.target.value)} />
            <em>분</em>
          </div>
        </label>

        <fieldset>
          <legend>이해도</legend>
          <div className="scheduler-record__rating">
            {[1, 2, 3, 4, 5].map((score) => (
              <button
                type="button"
                className={understanding >= score ? 'is-selected' : ''}
                onClick={() => setUnderstanding(score)}
                aria-label={`이해도 ${score}점`}
                key={score}
              >★</button>
            ))}
          </div>
        </fieldset>

        <label>
          <span>메모 <small>선택</small></span>
          <textarea
            className="scheduler-record__memo"
            value={memo}
            onChange={(event) => setMemo(event.target.value)}
            maxLength={1000}
            rows={3}
          />
        </label>

        {error && <p className="scheduler-form__error" role="alert">{error}</p>}
        <button type="submit" className="scheduler-record__save" disabled={isSaving}>
          <FiCheckCircle aria-hidden="true" /> {isSaving ? '저장 중...' : '완료 기록 저장'}
        </button>
      </form>
    </div>
  );
};

export default CompletionRecordModal;
